function init_home() {

    // Authors list dropdown
    $('body.home .our_authors_dropdown').on('click', function () {
        $('body.home .lc-author-list').toggle();
    });

    function rcpUserLoggedin() {

        if (getCookie('rcmg_guid')) {
            //Hide the subscribe btn on the navigation
            if (is_ad_free_user()) {
                if ($('body').hasClass('home')) {
                    //hidding the button
                    $('.search-wrapper .subscription').hide();
                    $('.user-account-wrapper').show();
                }
            }


            //user is loggedin
            // $('.rcmg-account .user-icon').attr('src', '/asset/img/logged-in-user.png');
            $('.rcmg-account > a').addClass('logged-in-user');

            appendUserMenu();

            $(document).on('click', '.logged-in-user', function (e) {
                e.preventDefault();
                $(this).parent().toggleClass('acitve-menu');

            });

            $(document).on('click', '.rcmg_sign_out', function (e) {
                e.preventDefault();
                clear_token_cookies(true);

            });

        } else {

            $(document).on('click', '.rcmg-account .rcmg_sign_in', function (e) {
                e.preventDefault();
                loginModal.loadModal("sign-in-up");

            });
        }
    }

    function appendUserMenu() {
        var username = getCookie('rcmg_username');
        var html = '<div class="logged-in-user-options">' +
            '<a href="/dashboard/"><span class="user-username">Hello ' + username + '</span> </a> | <a href="javascript:void(0)"> <span class="rcmg_sign_out"> Logout </span></a>' +
            '</div>';

        $('.rcmg-account').append(html);
    }

    //checks if its an Ad-free user
    function is_ad_free_user() {
        if (typeof getCookie == 'function') {
            if (getCookie('evaf')) {
                return true;
            }
        }
        return false;
    }

    //Search toggle
    $('.home-search img').on('click', function () {
        $('.desktop-search-input-container').toggleClass('desktop-search-active');
    });

    /*MC Campaing login users */
    $(document).ready(function () {
        if (!readCookie('rcmg_guid')) {
            if (Utils.get_query_param('login_modal')) {
                loginModal.loadModal("sign-in-up");
            }
        }

        /*Checking if user is logged in
         * Only on index page
         * */
        if (getCookie('rcmg_guid') && $('body').hasClass('home')) {
            var html_account_menu = '  <a href="#" class="user-account">Account</a>' +
                '                        <ul class="user-account-options">' +
                '                            <li><a href="/dashboard"> Dashboard </a></li>' +
                '                            <li><a href="#" class="rcmg_sign_out"> Logout</a></li>' +
                '                        </ul>';


            $('.user-account-wrapper').html(html_account_menu);


            $('.user-account').click(function (e) {
                e.preventDefault();
                $('ul.user-account-options').toggleClass('active');
            });


        }

    });

    rcpUserLoggedin();


    // <script async="" src="https://cdn.confiant-integrations.net/7Wu_Kxa62SVklAT2KI86xg35u9c/gpt_and_prebid/config.js"></script>
    Utils.load_script("https://cdn.confiant-integrations.net/7Wu_Kxa62SVklAT2KI86xg35u9c/gpt_and_prebid/config.js");

    // <script src="https://tags.catapultx.com/bootstrapper?group-id=CnfQb7YpPfsM9M5gbVkz&video-container=realclear_jwplayer_parent_1" defer></script>
    Utils.load_script("https://tags.catapultx.com/bootstrapper?group-id=CnfQb7YpPfsM9M5gbVkz&video-container=realclear_jwplayer_parent_1", {"defer": "true"});
}

export default init_home;